import {
  FETCH_PROFILE,
  FETCH_PROFILE_SUCCESS,
  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  RESTORE_UPDATE_PROFILE_INITIAL,
  ADD_BANK,
  ADD_BANK_SUCCESS,
  FETCH_ALL_BANKS,
  FETCH_ALL_BANKS_SUCCESS,
  FETCH_WALLET_DETAILS,
  FETCH_WALLET_DETAILS_SUCCESS,
  WITHDRAW_FUNDS,
  WITHDRAW_FUNDS_SUCCESS,
  RESTORE_ADD_BANK_INITIAL,
  RESTORE_WITHDRAW_FUNDS_INITIAL,
  CANCEL_SUBSCRIPTION,
  CANCEL_SUBSCRIPTION_SUCCESS,
  CANCEL_TRIAL,
  CANCEL_TRIAL_SUCCESS,
  RESTORE_CANCEL_SUBSCRIPTION_INITIAL,
  RESTORE_CANCEL_TRIAL_INITIAL,
  REACTIVATE_TRIAL,
  REACTIVATE_TRIAL_SUCCESS,
  RESTORE_REACTIVATE_TRIAL_INITIAL,
  REACTIVATE_SUBSCRIPTION,
  REACTIVATE_SUBSCRIPTION_SUCCESS,
  RESTORE_REACTIVATE_SUBSCRIPTION_INITIAL,
  WEB_PURCHASE,
  WEB_PURCHASE_SUCCESS,
  RESTORE_WEB_PURCHASE_INITIAL,
  FETCH_SUBSCRIPTION_DETAILS,
  FETCH_SUBSCRIPTION_DETAILS_SUCCESS,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  RESTORE_CHANGE_PASSWORD_INITIAL,
  DELETE_ACCOUNT,
  DELETE_ACCOUNT_SUCCESS,
  RESTORE_DELETE_ACCOUNT_INITIAL,
  UPLOAD_PROFILE_IMAGE,
  UPLOAD_PROFILE_IMAGE_SUCCESS,
  RESTORE_UPLOAD_PROFILE_IMAGE_INITIAL,
  FETCH_LEADERBOARD_SUMMARY,
  FETCH_LEADERBOARD_SUMMARY_SUCCESS,
  FETCH_LEADERBOARD_CATEGORY,
  FETCH_LEADERBOARD_CATEGORY_SUCCESS,
  FETCH_LEADERBOARD_CATEGORY_FAILURE,
  FETCH_ANALYTICS_OVERVIEW_SUMMARY,
  FETCH_ANALYTICS_OVERVIEW_SUMMARY_SUCCESS,
  FETCH_ANALYTICS_OVERVIEW_SUMMARY_FAILURE,
  FETCH_ANALYTICS_READING_HISTORY,
  FETCH_ANALYTICS_READING_HISTORY_SUCCESS,
  FETCH_ANALYTICS_READING_HISTORY_FAILURE,
  FETCH_ANALYTICS_READING_STREAK,
  FETCH_ANALYTICS_READING_STREAK_SUCCESS,
  FETCH_ANALYTICS_READING_STREAK_FAILURE,
  FETCH_ANALYTICS_ACHIEVEMENTS,
  FETCH_ANALYTICS_ACHIEVEMENTS_SUCCESS,
  FETCH_ANALYTICS_ACHIEVEMENTS_FAILURE,
  FETCH_ANALYTICS_INSIGHTS,
  FETCH_ANALYTICS_INSIGHTS_SUCCESS,
  FETCH_ANALYTICS_INSIGHTS_FAILURE,
  FETCH_READING_PREFERENCES,
  FETCH_READING_PREFERENCES_SUCCESS,
  FETCH_READING_PREFERENCES_FAILURE,
  UPDATE_READING_PREFERENCES,
  UPDATE_READING_PREFERENCES_SUCCESS,
  UPDATE_READING_PREFERENCES_FAILURE,
} from "../ActionTypes";

export const fetchProfile = () => ({
  type: FETCH_PROFILE,
});

export const fetchProfileSuccess = (payload) => ({
  type: FETCH_PROFILE_SUCCESS,
  payload,
});

export const updateProfile = ({ fullname, phone, dob, country_id, gender }) => ({
  type: UPDATE_PROFILE,
  payload: {
    fullname,
    phone,
    dob,
    country_id,
    gender,
  },
});

export const updateProfileSuccess = (payload) => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload,
});

export const restoreUpdateProfileInitial = () => ({
  type: RESTORE_UPDATE_PROFILE_INITIAL,
});

export const addBank = ({ bank_code, account_number }) => ({
  type: ADD_BANK,
  payload: {
    bank_code,
    account_number,
  },
});

export const addBankSuccess = (payload) => ({
  type: ADD_BANK_SUCCESS,
  payload,
});

export const restoreAddBankInitial = () => ({
  type: RESTORE_ADD_BANK_INITIAL,
});

export const fetchAllBanks = () => ({
  type: FETCH_ALL_BANKS,
});

export const fetchAllBanksSuccess = (payload) => ({
  type: FETCH_ALL_BANKS_SUCCESS,
  payload,
});

export const fetchWalletDetails = () => ({
  type: FETCH_WALLET_DETAILS,
});

export const fetchWalletDetailsSuccess = (payload) => ({
  type: FETCH_WALLET_DETAILS_SUCCESS,
  payload,
});

export const withdrawFunds = ({ amount }) => ({
  type: WITHDRAW_FUNDS,
  payload: {
    amount,
  },
});

export const withdrawFundsSuccess = (payload) => ({
  type: WITHDRAW_FUNDS_SUCCESS,
  payload,
});

export const restoreWithdrawFundsInitial = () => ({
  type: RESTORE_WITHDRAW_FUNDS_INITIAL,
});

export const cancelTrial = () => ({
  type: CANCEL_TRIAL,
});

export const cancelTrialSuccess = (payload) => ({
  type: CANCEL_TRIAL_SUCCESS,
  payload,
});

export const restoreCancelTrialInitial = () => ({
  type: RESTORE_CANCEL_TRIAL_INITIAL,
});

export const cancelSubscription = () => ({
  type: CANCEL_SUBSCRIPTION,
});

export const cancelSubscriptionSuccess = (payload) => ({
  type: CANCEL_SUBSCRIPTION_SUCCESS,
  payload,
});

export const restoreCancelSubscriptionInitial = () => ({
  type: RESTORE_CANCEL_SUBSCRIPTION_INITIAL,
});

export const reactivateTrial = () => ({
  type: REACTIVATE_TRIAL,
});

export const reactivateTrialSuccess = (payload) => ({
  type: REACTIVATE_TRIAL_SUCCESS,
  payload,
});

export const restoreReactivateTrialInitial = () => ({
  type: RESTORE_REACTIVATE_TRIAL_INITIAL,
});

export const reactivateSubscription = () => ({
  type: REACTIVATE_SUBSCRIPTION,
});

export const reactivateSubscriptionSuccess = (payload) => ({
  type: REACTIVATE_SUBSCRIPTION_SUCCESS,
  payload,
});

export const restoreReactivateSubscriptionInitial = () => ({
  type: RESTORE_REACTIVATE_SUBSCRIPTION_INITIAL,
});

export const fetchSubscriptionDetails = () => ({
  type: FETCH_SUBSCRIPTION_DETAILS,
});

export const fetchSubscriptionDetailsSuccess = (payload) => ({
  type: FETCH_SUBSCRIPTION_DETAILS_SUCCESS,
  payload,
});

export const webPurchase = (param) => ({
  type: WEB_PURCHASE,
  payload: param,
});

export const webPurchaseSuccess = (payload) => ({
  type: WEB_PURCHASE_SUCCESS,
  payload,
});

export const restoreWebPurchaseInitial = () => ({
  type: RESTORE_WEB_PURCHASE_INITIAL,
});

export const changePassword = ({ current_password, password }) => ({
  type: CHANGE_PASSWORD,
  payload: {
    password,
    current_password,
  },
});

export const changePasswordSuccess = (payload) => ({
  type: CHANGE_PASSWORD_SUCCESS,
  payload,
});

export const restoreChangePasswordInitial = () => ({
  type: RESTORE_CHANGE_PASSWORD_INITIAL,
});

export const deleteAccount = (email) => ({
  type: DELETE_ACCOUNT,
  payload: email,
});

export const deleteAccountSuccess = (payload) => ({
  type: DELETE_ACCOUNT_SUCCESS,
  payload,
});

export const restoredeleteAccountInitial = () => ({
  type: RESTORE_DELETE_ACCOUNT_INITIAL,
});

export const uploadProfileImage = (payload) => ({
  type: UPLOAD_PROFILE_IMAGE,
  payload,
});

export const uploadProfileImageSuccess = (payload) => ({
  type: UPLOAD_PROFILE_IMAGE_SUCCESS,
  payload,
});

export const restoreUploadProfileImageInitial = () => ({
  type: RESTORE_UPLOAD_PROFILE_IMAGE_INITIAL,
});

export const fetchLeaderBoardSummary = () => ({
  type: FETCH_LEADERBOARD_SUMMARY,
});

export const fetchLeaderBoardSummarySuccess = (payload) => ({
  type: FETCH_LEADERBOARD_SUMMARY_SUCCESS,
  payload,
});

export const fetchLeaderBoardCategory = ({ category, page = 1, limit = 10 }) => ({
  type: FETCH_LEADERBOARD_CATEGORY,
  payload: { category, page, limit },
});

export const fetchLeaderBoardCategorySuccess = (payload) => ({
  type: FETCH_LEADERBOARD_CATEGORY_SUCCESS,
  payload,
});

export const fetchLeaderBoardCategoryFailure = () => ({
  type: FETCH_LEADERBOARD_CATEGORY_FAILURE,
});

export const fetchAnalyticsOverviewSummary = (range = "week") => ({
  type: FETCH_ANALYTICS_OVERVIEW_SUMMARY,
  payload: { range },
});

export const fetchAnalyticsOverviewSummarySuccess = (payload) => ({
  type: FETCH_ANALYTICS_OVERVIEW_SUMMARY_SUCCESS,
  payload,
});

export const fetchAnalyticsOverviewSummaryFailure = () => ({
  type: FETCH_ANALYTICS_OVERVIEW_SUMMARY_FAILURE,
});

export const fetchAnalyticsReadingHistory = (page = 1) => ({
  type: FETCH_ANALYTICS_READING_HISTORY,
  payload: { page },
});

export const fetchAnalyticsReadingHistorySuccess = (payload) => ({
  type: FETCH_ANALYTICS_READING_HISTORY_SUCCESS,
  payload,
});

export const fetchAnalyticsReadingHistoryFailure = () => ({
  type: FETCH_ANALYTICS_READING_HISTORY_FAILURE,
});

export const fetchAnalyticsReadingStreak = () => ({
  type: FETCH_ANALYTICS_READING_STREAK,
});

export const fetchAnalyticsReadingStreakSuccess = (payload) => ({
  type: FETCH_ANALYTICS_READING_STREAK_SUCCESS,
  payload,
});

export const fetchAnalyticsReadingStreakFailure = () => ({
  type: FETCH_ANALYTICS_READING_STREAK_FAILURE,
});

export const fetchAnalyticsAchievements = () => ({
  type: FETCH_ANALYTICS_ACHIEVEMENTS,
});

export const fetchAnalyticsAchievementsSuccess = (payload) => ({
  type: FETCH_ANALYTICS_ACHIEVEMENTS_SUCCESS,
  payload,
});

export const fetchAnalyticsAchievementsFailure = () => ({
  type: FETCH_ANALYTICS_ACHIEVEMENTS_FAILURE,
});

export const fetchAnalyticsInsights = (year = new Date().getFullYear()) => ({
  type: FETCH_ANALYTICS_INSIGHTS,
  payload: { year },
});

export const fetchAnalyticsInsightsSuccess = (payload) => ({
  type: FETCH_ANALYTICS_INSIGHTS_SUCCESS,
  payload,
});

export const fetchAnalyticsInsightsFailure = () => ({
  type: FETCH_ANALYTICS_INSIGHTS_FAILURE,
});

export const fetchReadingPreferences = () => ({
  type: FETCH_READING_PREFERENCES,
});

export const fetchReadingPreferencesSuccess = (payload) => ({
  type: FETCH_READING_PREFERENCES_SUCCESS,
  payload,
});

export const fetchReadingPreferencesFailure = () => ({
  type: FETCH_READING_PREFERENCES_FAILURE,
});

export const updateReadingPreferences = (payload) => ({
  type: UPDATE_READING_PREFERENCES,
  payload,
});

export const updateReadingPreferencesSuccess = (payload) => ({
  type: UPDATE_READING_PREFERENCES_SUCCESS,
  payload,
});

export const updateReadingPreferencesFailure = () => ({
  type: UPDATE_READING_PREFERENCES_FAILURE,
});
